import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    open: false,
    entityName: null,
    search: null,
    /** 그리드 셀 수정·저장·업로드 허용 여부. 기본 false(조회/다운로드 전용) */
    editable: false,
};

const excelGridSlice = createSlice({
    name: 'excelGrid',
    initialState,
    reducers: {
        openExcelGrid(state, action) {
            const {entityName, search, editable} = action.payload;
            state.open = true;
            state.entityName = entityName ?? null;
            state.search = search ?? {};
            state.editable = editable === true;
        },
        closeExcelGrid(state) {
            state.open = false;
            state.entityName = null;
            state.search = null;
            state.editable = false;
        },
    },
});

export const {openExcelGrid, closeExcelGrid} = excelGridSlice.actions;
export default excelGridSlice.reducer;
